// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__2eUly","location":"Header_location__juf-z"};